import classNames from 'classnames';
import React from 'react';
import './index.scss';
export function Footer(props) {
    const { index, value, swipeTo } = props;
    if (value?.length <= 1)
        return null;
    return (React.createElement("div", { className: "cn-ui-m-image-viewer-footer" }, value.map((_, i) => (React.createElement("span", { key: _, onClick: (e) => {
            e.stopPropagation();
            swipeTo(i);
        }, className: classNames('cn-ui-m-image-viewer-footer-item', {
            'cn-ui-m-image-viewer-footer-item-active': i === index % value.length,
        }) },
        React.createElement("span", { className: "cn-ui-m-image-viewer-footer-item-inner" }))))));
}
